import { styled } from '@aibi-ui/core';
import { useMemo } from 'react';

const Container = styled.div<{ size: string }>`
  border-radius: 50%;
  overflow: hidden;
  width: ${props => props.size};
  height: ${props => props.size};
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: inherit;
  flex: none;
`;

const getUsername = (username?: string) => {
  if (!username) return '用户';

  const isChinese = /^[\u4e00-\u9fa5]/.test(username);
  if (isChinese) {
    // 匹配所有中文字符，并取最后一个
    const chineseChars = username.match(/[\u4e00-\u9fa5]/g);
    return chineseChars?.[chineseChars.length - 1] || '';
  } else {
    const first = username[0] || '';
    const second = username[1] || '';
    if (/[\u4e00-\u9fa5]/.test(second)) {
      return first;
    } else {
      return first + second;
    }
  }
};

const Avatar: React.FC<
  (
    | {
        name: string;
      }
    | { url: string }
  ) & { size?: string | number } & React.HTMLAttributes<HTMLDivElement>
> = props => {
  const { size: sizeProp, ...rest } = props;
  const size = useMemo(() => {
    const sizeValue = sizeProp || '36px';
    return typeof sizeValue === 'number' ? `${sizeValue}px` : sizeValue;
  }, [sizeProp]);
  if ('name' in props) {
    return (
      <Container
        {...rest}
        className={['bg-[#5687ff]', rest.className || ''].join(' ')}
        size={size}
      >
        {getUsername(props.name)}
      </Container>
    );
  }
  if ('url' in props) {
    return (
      <Container {...rest} size={size}>
        <img src={props.url} />
      </Container>
    );
  }
  return <Container {...rest} size={size} />;
};
export default Avatar;
